export default {
	'body': 14,
}